<template>
    <div class="topbar-detail">
        <div class="flex justify-center w-full p-5 relative">
            <div class="absolute left-5">
                <img @click="clickBack()" v-if="isShowBack && !isTextWhite" class="h-4.5 mt-1" src="@/assets/icon/ic-back.svg" alt="" />
                <img @click="clickBack()" v-if="isShowBack && isTextWhite" class="h-4.5 mt-1" src="@/assets/icon/ic-back-white.svg" alt="" />
            </div>
            <div class="w-full text-center text-26 px-7 leading-7" :class="isTextWhite ? 'text-white' : 'text-blue-1'" v-if="title != ''">
                {{title}}
            </div>
            <div class="absolute right-5 flex">
                <img @click="clickShare()" v-if="isShowShare" class="h-4.5 mt-1 ml-2" src="@/assets/icon/ic-share.svg" alt="" />
                <img @click="clickFav()" v-if="isShowFavorite && !isFavorite" class="h-4.5 mt-1 ml-2" src="@/assets/icon/ic-fav.svg" alt="" />
                <img @click="clickFav()" v-if="isShowFavorite && isFavorite" class="h-4.5 mt-1 ml-2" src="@/assets/icon/ic-fav-active.svg" alt="" />
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "TopBarDetail",
    mixins: [LocaleMixin],
    props: {
        title: { type: String, default: '' },
        isShowBack: { type: Boolean, default: false },
        isShowFavorite: { type: Boolean, default: false },
        isShowShare: { type: Boolean, default: false },
        isTextWhite: { type: Boolean, default: false }
    },
    data: function() {
        return {
            pageActive: this.$route.name,
            isFavorite: false,
            showLangSwitch: false,
        };
    },
    methods: {
        clickBack: function() {
            this.$emit('clickBack');
        },
        clickFav: function() {
            this.$emit('clickFav');
        },
        clickShare: function() {
            this.$emit('clickShare');
        },
        updateFavorite: function(isFavorite) {
            this.isFavorite = isFavorite;
        }
    },
}
</script>
<style lang="scss" scoped>
.topbar-detail {
    width: 100vw;
    height: 72px;
}
</style>
